import { userFilter } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const updateUserFilterMutation = gql`
    mutation UpdateUserFilter($userFilter: UserFilterInput!) {
        updateUserFilter(userFilter: $userFilter) {
            ...userFilter
        }
    }
    ${userFilter}
`;

export const shareFilterMutation = gql`
    mutation ShareFilter ($filterId: Long!, $users: [Long]!) {
        shareFilter(filterId: $filterId, users: $users)
    }
`;

export const deleteFilterMutation = gql`
    mutation DeleteFilter ($filterId: Long!) {
        deleteFilter(filterId: $filterId)
    }
`;

export const updateUserFiltersMutation = gql`
    mutation UpdateUserFilters($userFilters: [UserFilterInput]!) {
        updateUserFilters(userFilters: $userFilters) {
            ...userFilter
        }
    }
    ${userFilter}
`;
